import classNames from 'classnames/bind';
import styles from './KinhDich.module.scss';
import { Container, Grid, Hidden } from '@mui/material';
import images from '../../../assets/images';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import KinhDichDetail from './KinhDichDetail';
const cx = classNames.bind(styles);

let arrMenhSim = [
  { link: '/sim-hop-menh?m=moc', title: 'Mệnh Mộc', title_mobile: 'Mộc', images: images?.menh_moc, css: 'moc' },
  { link: '/sim-hop-menh?m=hoa', title: 'Mệnh Hỏa', title_mobile: 'Hỏa', images: images?.menh_hoa, css: 'hoa' },
  { link: '/sim-hop-menh?m=tho', title: 'Mệnh Thổ', title_mobile: 'Thổ', images: images?.menh_tho, css: 'tho' },
  { link: '/sim-hop-menh?m=kim', title: 'Mệnh Kim', title_mobile: 'Kim', images: images?.menh_kim, css: 'kim' },
  { link: '/sim-hop-menh?m=thuy', title: 'Mệnh Thủy', title_mobile: 'Thủy', images: images?.menh_thuy, css: 'thuy' },
];

export default function SimHopMenh() {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const menhSim = urlParams.get('m');
  const mangSim = urlParams.get('mang') || '';
  const rangeSim = urlParams.get('range') || '';
  const bySim = urlParams.get('by') || '';

  const [arrMenh, setArrMenh] = useState([]);

  useEffect(() => {
    if (menhSim) {
      const selected = arrMenhSim.find((item) => item.link.includes(`m=${menhSim}`));

      if (selected) {
        const others = arrMenhSim.filter((item) => item !== selected);
        const center = Math.floor(others.length / 2);

        const newArr = [...others.slice(0, center), selected, ...others.slice(center)];

        setArrMenh(newArr);
      } else {
        setArrMenh(arrMenhSim); // không có mệnh trùng thì giữ nguyên
      }
    } else {
      setArrMenh(arrMenhSim); // không có param m thì giữ nguyên
    }
  }, [menhSim]);
  return (
    <Grid item xs={12} md={12}>
      <Container sx={{ p: '0px' }} maxWidth="lg">
        <div className={cx('bgt', 'sim-title-dn', 'flex-end')}>
          <div className={cx('l1')}></div>
          <div className={cx('l2')}></div>
          <div className={cx('r1')}></div>
          <div className={cx('r2')}></div>
          <div className={cx(menhSim + '-size')}>
            {menhSim
              ? 'Phong Thủy Hợp ' +
                arrMenh?.filter((item) => {
                  return item.css === menhSim;
                })[0]?.title
              : 'Phong Thủy Hợp Mệnh'}
          </div>
        </div>
        {menhSim ? (
          <>
            <Hidden only={['sm', 'xs']}>
              <Grid container sx={{ mt: 2 }} justifyContent={'center'} spacing={2} alignItems={'flex-end'}>
                {arrMenh?.map((row, i) => (
                  <Grid key={i} item xs={6} md={2} className={cx('text-center')}>
                    <a href={row.link}>
                      {menhSim ? (
                        <img src={row?.images} width={menhSim != row.css ? '80px' : ''} />
                      ) : (
                        <img src={row?.images} />
                      )}
                      <div className={cx('font-menh', `${row.css}-size`)}>{row.title}</div>
                    </a>
                  </Grid>
                ))}
              </Grid>
            </Hidden>

            <Hidden only={['md', 'lg', 'xl']}>
              <Grid container sx={{ mt: 2 }} justifyContent={'center'} spacing={2} alignItems={'flex-end'}>
                {arrMenh?.map((row, i) => (
                  <Grid key={i} item xs={menhSim != row.css ? 2 : 3} md={2} className={cx('text-center')}>
                    <a href={row.link}>
                      {menhSim ? (
                        <img src={row?.images} width={menhSim != row.css ? '40px' : '90px'} />
                      ) : (
                        <img src={row?.images} />
                      )}
                      <div className={cx('font-menh', `${row.css}-size`)}>{row.title_mobile}</div>
                    </a>
                  </Grid>
                ))}
              </Grid>
            </Hidden>
          </>
        ) : (
          <Grid container sx={{ mt: 2 }} justifyContent={'center'} spacing={2} alignItems={'flex-end'}>
            {arrMenh?.map((row, i) => (
              <Grid key={i} item xs={6} md={2} className={cx('text-center')}>
                <a href={row.link}>
                  <img src={row?.images} />
                  <div className={cx('font-menh', `${row.css}-size`)}>{row.title}</div>
                </a>
              </Grid>
            ))}
          </Grid>
        )}

        {menhSim && (
          <KinhDichDetail
            menh={menhSim}
            orderBy={bySim === '1' ? 'ASC' : bySim === '2' ? 'DESC' : ''}
            nhamang={mangSim}
            RangePrice={rangeSim}
          />
        )}
      </Container>
    </Grid>
  );
}
